import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { HkbkfacilitiesRoutingModule } from './hkbkfacilities-routing.module';
import { HkbkfacilitiesListComponent } from './hkbkfacilities-list/hkbkfacilities-list.component';
import { HkbkfacilitiesCreateComponent } from './hkbkfacilities-create/hkbkfacilities-create.component';

@NgModule({
  declarations: [HkbkfacilitiesListComponent, HkbkfacilitiesCreateComponent],
  imports: [
    CommonModule,
    HkbkfacilitiesRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class HkbkfacilitiesModule { }
